import React from "react";
import Modal from "../index";
import {FlexContainer, Loader, Text} from "../../../design";

type Props = {
  isOpen: boolean,
  header: string,
  body: string
}

const TransactionModal = (props : Props) => {
  return (
    <Modal isOpen={props.isOpen}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
            paddingTop="10px"
            paddingLeft="10px"
            paddingRight="10px"
            paddingBottom="10px"
        >
            <div
                style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '100%',
                    position: 'relative',
                    margin: '20px auto',
                }}
            >
                <Loader/>
            </div>
            <Text
                fontSize="20px"
                fontWeight='600'
            >
                Please wait
            </Text>
            <Text
                fontSize="20px"
                fontWeight='600'
                textAlign='center'
            >
                {props.header||"Your transaction is being processed"}
            </Text>
            <Text
                fontSize="16px"
                textAlign='center'
            >
                {props.body||"You will be redirected when the transaction is successful."}
            </Text>
        </FlexContainer>
    </Modal>
  )
};

export default TransactionModal;
